import Vue from 'vue';
import Router from 'vue-router';

import Index from './pages/Index.vue';

import Marketing from './pages/Marketing/ad.vue';
import MarketingVideo from './pages/Marketing/ad_video.vue';


import Legacy from './pages/Legacy.vue';
import Reports from './pages/reports.vue';
import TMS from './pages/TMS.vue';
import WMS from './pages/WMS.vue';
import FB from './pages/Apps/FreightBillStatus.vue';

import stripeemailverification from './pages/_stripeemailverification.vue';

import GPS from './pages/GPS.vue';
import MainNavbar from './layout/MainNavbar.vue';

import MainFooter from './layout/MainFooter.vue';
import adFooter from './layout/adFooter.vue';
//import MapFooter from './layout/MapFooter.vue';
import EmptyFooter from './layout/EmptyFooter.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'index',
      components: { default: Index, header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/stripeemailverification',
      name: 'stripeemailverification',
      components: { default: stripeemailverification},
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },         
    {
      path: '/warehousinganddistribution',
      name: 'marketing',
      components: { default: Marketing, footer: adFooter},
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },   
    
    {
      path: '/contactuswarehousinganddistribution',
      name: 'adContact',
      components: { default: () => import('./pages/Marketing/adContact.vue')},
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },  
    {
      path: '/requestcallback',
      name: 'requestcallback',
      components: { default: () => import('./pages/Marketing/requestcallback.vue')},
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },      
    {
      path: '/thankyou',
      name: 'thankyou',
      components: { default: () => import('./pages/Marketing/thankyou.vue')},
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },          
    {
      path: '/FreightBillStatus',
      name: 'FreightBillStatus',
      components: { default: FB}
    },  

    /*
    {
      path: '/payments',
      name: 'payments',
      components: { default: () => import('./pages/payments.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    */    
    {
      path: '/scanny',
      name: 'scanny',
      components: { default: () => import('./pages/Apps/Scanny.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },

    {
      path: '/quote',
      name: 'quote',
      components: { default: () => import(/* webpackChunkName: "quote" */ './pages/Quote.vue'), header: MainNavbar, footer: MainFooter },
      //() => import(/* webpackChunkName: "group-foo" */ './Bar.vue')
      //() => import(/* webpackChunkName: "group-foo" */ './Baz.vue')
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },    
    {
      path: '/services',
      name: 'services',
      components: { default: () => import('./pages/Services.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/warehouse',
      name: 'warehouse',
      components: { default: () => import('./pages/Services/Warehousing.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/transportation',
      name: 'transportation',
      components: { default: () => import('./pages/Services/Transportation.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/freightbrokerage',
      name: 'freightbrokerage',
      components: { default: () => import('./pages/Services/FreightBrokerage.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
/*----------------------------------------*/
    {
      path: '/about',
      name: 'about',
      components: { default: () => import('./pages/about.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/contact',
      name: 'contact',
      components: { default: () => import('./pages/contact.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },  
    {
      path: '/contactus',
      name: 'contactus',
      components: { default: () => import('./pages/ContactUs.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },      
    {
      path: '/company',
      name: 'company',
      components: { default: () => import('./pages/Company.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    }, 
    {
      path: '/career',
      name: 'career',
      components: { default: () => import('./pages/Careerbak.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },            
    {
      path: '/careerbak',
      name: 'careerbak',
      components: { default: () => import('./pages/Careerbak.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },  
    {
      path: '/contactcareer',
      name: 'contactcareer',
      components: { default: () => import('./pages/ContactCareer.vue'), header: MainNavbar, footer: MainFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },         
    {
      path: '/legacy',
      name: 'legacy',
      components: { default: Legacy, header: MainNavbar, footer: EmptyFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/reports',
      name: 'reports',
      components: { default: Reports, header: MainNavbar, footer: EmptyFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },    
    {
      path: '/tms',
      name: 'tms',
      components: { default: TMS, header: MainNavbar, footer: EmptyFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
    {
      path: '/wms',
      name: 'wms',
      components: { default: WMS, header: MainNavbar, footer: EmptyFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },
  
    {
      path: '/gps',
      name: 'gps',
      components: { default: GPS, header: MainNavbar, footer: EmptyFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },        
    {
      path: '/signpod',
      name: 'Signpod',      
      components: { default: () => import(/* webpackChunkName: "ScreenShare" */ './pages/Apps/signpod.vue'), header: MainNavbar },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    },   
    {
      path: '/bookingstatus',
      name: 'bookingstatus',
      /*
      components: { default: ScreenShare, header: MainNavbar, footer: EmptyFooter }, 
      */
      components: { default: () => import(/* webpackChunkName: "ScreenShare" */ './pages/Apps/BookingStatus.vue'), header: MainNavbar, footer: EmptyFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    }, 

    {
      path: '/UPSShip_LEGACY',
      name: 'upsship_LEGACY',
      components: { default: () => import(/* webpackChunkName: "ScreenShare" */ './pages/Apps/UPSShip_LEGACY.vue'), header: MainNavbar, footer: EmptyFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    }, 
    {
      path: '/UPSShip',
      name: 'upsship',
      components: { default: () => import(/* webpackChunkName: "ScreenShare" */ './pages/Apps/UPSShipV2.vue'), header: MainNavbar, footer: EmptyFooter },
      props: {
        header: { colorOnScroll: 400 },
        footer: { backgroundColor: 'black' }
      }
    }, 

  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
